/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseselectavalidcountry4Inputs */

const en_pleaseselectavalidcountry4 = /** @type {(inputs: Pleaseselectavalidcountry4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a valid country`)
};

const de_pleaseselectavalidcountry4 = /** @type {(inputs: Pleaseselectavalidcountry4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähl ein gültiges Land`)
};

/**
* | output |
* | --- |
* | "Please select a valid country" |
*
* @param {Pleaseselectavalidcountry4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseselectavalidcountry4 = /** @type {((inputs?: Pleaseselectavalidcountry4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseselectavalidcountry4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseselectavalidcountry4(inputs)
	return de_pleaseselectavalidcountry4(inputs)
});
export { pleaseselectavalidcountry4 as "pleaseSelectAValidCountry" }